import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { SelectionLabel } from '../../../core/components/SelectionControl/label.js';
import { Checkbox } from './Checkbox/component.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
import { pickDataAttributes } from '../../../utils/pickDataAttributes.js';
var CheckboxControl = /*#__PURE__*/function (_React$Component) {
  function CheckboxControl(props) {
    var _this;
    _classCallCheck(this, CheckboxControl);
    _this = _callSuper(this, CheckboxControl, [props]);
    _defineProperty(_this, "onChange", function (checked, skipValueChange) {
      if (checked === _this.state.checked) return;
      _this.setState({
        checked: checked
      }, function () {
        var value;
        if (_this.props.checkboxValue) {
          value = checked ? _this.props.checkboxValue : undefined;
        } else {
          value = checked;
        }
        // order of calling onValueChange and onChange matters
        // when checkboxControl(MaterialCheckbox) is added inside Form
        if (typeof _this.props.onValueChange === 'function' && !skipValueChange) {
          _this.props.onValueChange(_defineProperty({}, _this.props.name, value));
        }
        if (typeof _this.props.onChange === 'function') {
          _this.props.onChange(value, skipValueChange);
        }
      });
    });
    _defineProperty(_this, "onCheckChange", function (event) {
      if (typeof _this.props.validateChange === 'function') {
        var performChange = _this.props.validateChange(event.currentTarget.checked);
        if (!performChange) {
          event.preventDefault();
          event.stopPropagation();
          event.currentTarget.checked = false;
          return;
        }
      }
      _this.onChange(event.currentTarget.checked);
    });
    _this.state = {
      checked: _this.getCheckedState(props)
    };
    return _this;
  }
  _inherits(CheckboxControl, _React$Component);
  return _createClass(CheckboxControl, [{
    key: "getCheckedState",
    value: function getCheckedState(props) {
      return props.checked || (props.dataValue === undefined || props.dataValue === 'false' ? false : props.dataValue);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        valueOverride = _this$props.valueOverride,
        dataValue = _this$props.dataValue;
      if (valueOverride && dataValue !== prevProps.dataValue) {
        this.onChange(dataValue, true);
        this.setState({
          checked: Boolean(dataValue)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        chakra = _this$props2.chakra,
        checkboxValue = _this$props2.checkboxValue,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        hideLabel = _this$props2.hideLabel,
        propId = _this$props2.id,
        inline = _this$props2.inline,
        label = _this$props2.label,
        labelClass = _this$props2.labelClass,
        name = _this$props2.name,
        padding = _this$props2.padding,
        type = _this$props2.type;
      var checked = this.state.checked;
      var id = propId || name;
      var checkClassName = _formatClassName([className, {
        'checkbox-inline': inline && type === 'checkbox'
      }, {
        disabled: disabled
      }, {
        'radio-inline': inline && type === 'radio'
      }]);
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, pickDataAttributes(this.props), {
        chakra: chakra,
        checkClassName: checkClassName,
        id: id,
        hideLabel: hideLabel,
        isChecked: checked,
        isDisabled: disabled,
        labelAction: "checkbox",
        name: name,
        onChange: this.onCheckChange,
        padding: padding,
        type: type,
        value: checkboxValue || String(checked)
      }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectionLabel, {
        label: children || label,
        className: labelClass
      }), checkboxValue ? null : /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: name,
        value: "false",
        disabled: checked
      })));
    }
  }]);
}(React.Component);
_defineProperty(CheckboxControl, "propTypes", {
  chakra: PropTypes.bool,
  checkboxValue: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string,
  dataValue: PropTypes.bool,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  id: PropTypes.string,
  inline: PropTypes.bool,
  label: PropTypes.string,
  labelClass: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  padding: PropTypes.object,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  validateChange: PropTypes.func,
  valueOverride: PropTypes.bool
});
_defineProperty(CheckboxControl, "defaultProps", {
  type: 'checkbox',
  forceStateUpdate: false
});
CheckboxControl.displayName = "CheckboxControl";
export { CheckboxControl };